/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { createRenderable } from '../renderable';
import { createGraphicsRenderItem } from '../webgl/render-item';
import { GlobalUniformSchema, BaseSchema, AttributeSpec, UniformSpec, DefineSpec, InternalSchema, SizeSchema, GlobalTextureSchema } from './schema';
import { PointsShaderCode } from '../shader-code';
import { ValueCell } from '../../mol-util';
export var PointsSchema = __assign(__assign(__assign({}, BaseSchema), SizeSchema), {
  aGroup: AttributeSpec('float32', 1, 0),
  aPosition: AttributeSpec('float32', 3, 0),
  dPointSizeAttenuation: DefineSpec('boolean'),
  dPointFilledCircle: DefineSpec('boolean'),
  uPointEdgeBleach: UniformSpec('f')
});
export function PointsRenderable(ctx, id, values, state, materialId) {
  var schema = __assign(__assign(__assign(__assign({}, GlobalUniformSchema), GlobalTextureSchema), InternalSchema), PointsSchema);

  var internalValues = {
    uObjectId: ValueCell.create(id)
  };
  var shaderCode = PointsShaderCode;
  var renderItem = createGraphicsRenderItem(ctx, 'points', shaderCode, schema, __assign(__assign({}, values), internalValues), materialId);
  return createRenderable(renderItem, values, state);
}